export default __webpack_public_path__ + "static/icon-3-5-3a8eae0b8bbc6feb5b2959b264c511fa.png";